export default class SliderModule {
    private _selectorId: string;

    constructor(selectorId: string) {
        this._selectorId = selectorId;
    }

    init() {
        ($(this._selectorId) as any).slick({
            dots: true,
            infinite: false,
            arrows: true,
            centerPadding: '0',
            slidesToShow: 3,
            initialSlide: 0,
            width: '1200px',
            slidesToScroll: 3,
            mobileFirst: false,
            responsive: [
                {
                    breakpoint: 1500,
                    settings: {
                        dots: false,
                        arrows: true,
                        draggable: false,
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        dots: false,
                        arrows: true,
                        draggable: false,
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        dots: false,
                        arrows: true,
                        draggable: false,
                        slidesToScroll: 2,
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        dots: false,
                        arrows: true,
                        draggable: true,
                        slidesToScroll: 1,
                        slidesToShow: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: false,
                        draggable: true,
                        slidesToScroll: 1,
                        slidesToShow: 1
                    }
                }
            ]
        });
    }
}


// WEBPACK FOOTER //
// ./Content/scripts/modules/slider/slider-module.ts